import React from "react";

const ConfirmModal = ({ h, t, message, onConfirm, onCancel }) => (
  <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }} onClick={onCancel}>
    <div style={{ background: h.cd, borderRadius: 14, padding: 24, maxWidth: 340, width: "100%", boxShadow: "0 10px 40px rgba(0,0,0,0.3)" }} onClick={e => e.stopPropagation()}>
      <p style={{ color: h.tx, fontSize: 15, fontWeight: 600, margin: "0 0 20px", lineHeight: 1.5 }}>{message}</p>
      <div style={{ display: "flex", gap: 10 }}>
        <button onClick={onConfirm} style={{ flex: 1, padding: "12px", borderRadius: 12, border: "none", background: h.rd, color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>{t.yesConfirm}</button>
        <button onClick={onCancel} style={{ flex: 1, padding: "12px", borderRadius: 12, border: "none", background: h.ib, color: h.tx, fontSize: 14, cursor: "pointer" }}>{t.cancel}</button>
      </div>
    </div>
  </div>
);

export default ConfirmModal;
